import { gql } from "@apollo/client";

export const joinWaitlist = gql`
  mutation SendNotification(
    $sendNotificationTemplateId: String!
    $sendNotificationEmails: [String]
  ) {
    sendNotification(
      templateId: $sendNotificationTemplateId
      emails: $sendNotificationEmails
    ) {
      message
    }
  }
`;
export const joinSubscription = gql`
  mutation SendNotification(
    $sendNotificationTemplateId: String!
    $sendNotificationEmails: [String]
  ) {
    sendNotification(
      templateId: $sendNotificationTemplateId
      emails: $sendNotificationEmails
    ) {
      message
    }
  }
`;
